export enum LocalStorageNamespace {
  AUTH = "auth",
  ON_BOARDING = "on_boarding",
  PRIVACY = "privacy",
  PREVIEW = "preview",
  VIDEO_CALL = "video_call",
}
